// All user-facing copy for the opted-in document types section lives in this one file.
// Every string below is an unapproved draft: it needs approval in the running build before
// the production deploy.

export const OPTED_IN_DOCUMENT_TYPES_COPY = {
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  title: 'Opted-in document types',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  helperText: 'The extra identity document types customers can use with this code.',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  editHelperText:
    'Select the extra identity document types customers can use with this code. Changes take effect when you save.',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  emptyState: 'No extra document types are opted in for this code.',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  editButtonLabel: 'Edit opted-in document types',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  cancelButton: 'Cancel',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  saveButton: 'Save',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  savingButton: 'Saving...',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  saveError: "Couldn't save. Nothing was changed.",
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  successToast: 'Opted-in document types updated successfully',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  failureToast: 'Failed to update opted-in document types',
} as const;

// Checkbox labels, keyed by the opt-in document type value. The list of types shown comes from
// the caller, not from this map: a type with no label here shows its raw value.
export const OPTED_IN_DOCUMENT_TYPE_LABELS: Readonly<Record<string, string>> = {
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  PhotoCard: 'Photo Card',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  ImmiCard: 'ImmiCard',
};
